const en = {
  100000001:'Key information',
  100000002:'Token Name',
  100000003:'Instance creator',
  100000004:'Instance Creation Time',
  100000005:'Basic information',
  100000006:'chain/protocol',
  100000007:'Smart contract address',
  100000008:'Issue Date',
  100000009:'Total Supply',
  100000010:'Circulation Supply',
  100000011:'Market Value',
  100000012:'Info',
  100000013:'Social media information',
  100000014:'Website',
  100000015:'White Paper',
  100000016:'Blockchain explorer',
  100000017:'Project Score',
  100000018:'Ranking',
  100000019:'Top',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Time Updated',
  100000027:'Security score',
  100000028:'Contract security score',
  100000029:'Risk project statistics',
  100000030:'Details of the contract code',
  100000031:'Buy Tax',
  100000032:'Sell Tax',
  100000033:'Is Honeypot',
  100000034:'Is Mintable',
  100000035:'Has Blacklist',
  100000036:'Has Whitelist',
  100000037:'Is Anti-whale',
  100000038:'Can Modify Tax',
  100000039:'Not Open Source',
  100000040:'Has Hidden Owner',
  100000041:'Can Self Destruct',
  100000042:'is Proxy Contract',
  100000043:'Can modify balance',
  100000044:'Has External Calls',
  100000045:'Can Regain Ownership',
  100000046:'Is Transfer Cooldown',
  100000047:'Is Transfer Pausable',
  100000048:'Ownership Not Renounced',
  100000049:'Is Anti-whale Modifiable',
  100000050:'Decimals Too Small',
  100000051:'Pulic Mint and Burn',
  100000052:'Burn Should Update Total Supply',
  100000053:'Burn Should Update Allowance',
  100000054:'Self Transfer Could Double The Balance',
  100000055:'Transfer More Than Balance Should Fail',
  100000056:'Allowance Not Adjusted During TransferFrom',
  100000057:'TransferFrom Should Not Use Spender Balance',
  100000058:'TransferFrom More Than Allowance',
  100000059:'BurnFrom Should update Total Supply',
  100000060:'Detect the buy tax of the token. Above 5% is considered a high tax rate',
  100000061:'Detect the sell tax of the token. Above 5% is considered a high tax rate',
  100000062:'Check if the token is a honeypot scam',
  100000063:'Check if more tokens can be minted',
  100000064:'Check if the token has a blacklist that can restrict users from swapping or transferring tokens.',
  100000065:'Check if the token has a whitelist that allows addresses to bypass any restrictions',
  100000066:'Check if the token has anti whale mechanisms',
  100000067:'Check if the token has a tax and the tax can be modified by privileged roles',
  100000068:'Check if the token has been verified on blockchain explorer',
  100000069:'Check if the token has a hidden owner that can manipulate the contract, even if ownership appears to have been renounced',
  100000070:'Check if the token can self-destruct',
  100000071:'Check if the token is a proxy contract that delegates function calls to an implementation contract',
  100000072:'Check if the token balance can be modified by privileged roles',
  100000073:'Check if the token calls external contracts',
  100000074:'Check if the token has a backdoor to regain ownership',
  100000075:'Check if the token has a transfer cooldown mechanism',
  100000076:'Check if trade of the token can be paused by privileged roles',
  100000077:'Check if the owner privilege has been renounced',
  100000078:'Check if the anti whale mechanisms of the token can be modified by privileged roles',
  100000079:'Check if the return value of `decimals()` function is greater than or equal to 5',
  100000080:'Check if calling `mint()` and `burn()` functions as random users will revert',
  100000081:'Check if calling the `burn()` function will update the `totalSupply` correctly',
  100000082:"Check if calling the `burnFrom()` function will update the allowance correctly",
  100000083:"Check if calling `transfer()` function with the recipient the same as the transaction sender will increase the sender's balance",
  100000084:'Check if calling `transfer()` function with an amount more than the balance will fail',
  100000085:"Check if the allowance of the spender are updated accordingly after calling `transferFrom()` function",
  100000086:"Check if calling `transferFrom()` function will use the balance of the spender",
  100000087:"Check if the allowance is updated correctly after calling `transferFrom()`, or if the transaction reverts if the amount is invalid",
  100000088:"Check if calling the `burnFrom()` function will update the `totalSupply` correctly",
  100000089:'Check if mint authority exists',
  100000090:'Check if freeze authority exists',
  100000091:'Reviews whether the metadata can be changed',
  100000092:'Critical',
  100000093:'Major',
  100000094:'Medium',
  100000095:'Minor',
  100000096:'Informational',
  100000097:'Mint Authority has been revoked',
  100000098:'Freeze Authority has been revoked',
  100000099:'Can change metadata',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default en


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/en.js